<template>
  <div class="subprogram-nba-coach-card">

    <div class="subprogram-nba-coach-card__buttons">
      <span
        v-text="i18n('entities.coach.label')"
        class="subprogram-nba-coach-card__title"
      />
      <!-- <router-link :to="{ name: 'coachNew' }">
        <el-button type="secondary">
          <app-i18n code="entities.coach.new.title"></app-i18n>
        </el-button>
      </router-link> -->
    </div>

    <div class="subprogram-nba-coach-card__table" v-loading="loading">
      <el-table
        v-if="coaches && coaches.length > 0"
        :data="coaches"
      >

        <el-table-column
          :label="fields.name.label"
          :prop="fields.name.name"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.firstName"
              v-text="presenter(scope.row, 'firstName')+' '+presenter(scope.row, 'lastName')"
            />
            <span
              v-else
              v-text="'-'"
            />
          </template>
        </el-table-column>
        
        <el-table-column
          :label="fields.type.label"
          :prop="fields.type.name"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.type"
              v-text="presenter(scope.row, 'type')"
            />
            <span
              v-else
              v-text="'-'"
            />
          </template>
        </el-table-column>

        <el-table-column
          :label="fields.teams.label"
          :prop="fields.teams.name"
        >
          <template slot-scope="scope">
            <app-i18n
              v-if="!scope.row.teams || !scope.row.teams.length"
              code="common.none"
            />
            <span
              v-else-if="scope.row.teams.length === 1"
              v-text="scope.row.teams[0].name"
            />

            <el-tooltip
              v-else
              effect="dark"
              :content="scope.row.teams.map(team => team.name).join('\n')"
              placement="bottom"
            >
              <app-i18n code="entities.team.list.multipleTeams" />
            </el-tooltip>

          </template>
        </el-table-column>

        <el-table-column
          :label="fields.email.label"
          :prop="fields.email.name"
          :width="280"
        >
          <template slot-scope="scope">
            <span
              v-if="scope.row.email"
              v-text="presenter(scope.row, 'email')"
            />
            <span
              v-else
              v-text="'-'"
            />
          </template>
        </el-table-column>

      </el-table>

      <app-empty-page
        v-else
        :icon-class="'icon-player'"
        :empty-text="i18n('entities.coach.empty')"
      />
    </div>
  </div>
</template>

<script>
import { i18n } from '@shared/i18n';
import { mapGetters } from 'vuex';
import { CoachModel } from '@modules/coach/coach-model';

export default {
  name: 'app-subprogram-nba-coach-card',
  props: {
    coaches: {
      type: Array,
    },
  },

  computed: {
    ...mapGetters({
      loading: 'subprogram/nbaTeam/summary/loading',
      dateFormat: 'auth/manage/dateFormat',
      timeFormat: 'auth/manage/timeFormat',
    }),
    fields() {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).fields();
    },
  },

  methods: {
    presenter(row, fieldName) {
      const { dateFormat, timeFormat} = this;
      return new CoachModel({ dateFormat, timeFormat }).presenter(row, fieldName);
    },
    i18n(code) {
      return i18n(code);
    },
  },
};
</script>

<style lang="scss" scoped>
.subprogram-nba-coach-card {
  padding-top: 40px;
  &__title {
    font-size: 20px;
    color: #6c6c6c;
    text-transform: uppercase;
  }
  &__table {
    box-shadow: -10px 10px 20px 0 rgba(30, 30, 30, 0.05);
    margin-top: 20px;
  }
}
</style>